<template>
  <label class="bold-label">{{ text }}<span v-if="required" class="required">*</span> </label>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Field',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.required {
  color: #da2a34;
  padding-left: 4px;
}
.bold-label {
  font-size: 14px;
  font-weight: 700;
}
</style>
